function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useContext } from "react";
import chroma from "chroma-js";
import ThemeContext from "../../ThemeProvider/ThemeContext";
export var useContrastTextDetails = function(props) {
    var theme = useContext(ThemeContext);
    var background = props.background, _foreground = props.foreground, foreground = _foreground === void 0 ? [] : _foreground, onLight = props.onLight, onDark = props.onDark, _compliance = props.compliance, compliance = _compliance === void 0 ? 'AA' : _compliance, _size = props.size, size = _size === void 0 ? 'small' : _size;
    var _background = background || theme.backgroundColor.base;
    var compliantContrastRatio;
    switch("".concat(compliance).concat(size)){
        case 'AAlarge':
            compliantContrastRatio = 3;
            break;
        case 'AAAsmall':
            compliantContrastRatio = 7;
            break;
        default:
            compliantContrastRatio = 4.5;
    }
    try {
        if (!_background) {
            throw Error('background prop was undefined. Please add an appropriate value for this prop.');
        }
        var _onLight = onLight || theme.font.color.onLight;
        var _onDark = onDark || theme.font.color.onDark;
        var isOnLight = chroma(_background).luminance() >= 0.5;
        var onLightFallbackForegrounds = [
            _onLight,
            theme.font.color.onLight,
            theme.font.color.base,
            'black'
        ];
        var onDarkFallbackForegrounds = [
            _onDark,
            theme.font.color.onDark,
            theme.font.color.fill,
            'white'
        ];
        var orderedFallbackForegrounds = isOnLight ? _toConsumableArray(onLightFallbackForegrounds).concat(_toConsumableArray(onDarkFallbackForegrounds)) : _toConsumableArray(onDarkFallbackForegrounds).concat(_toConsumableArray(onLightFallbackForegrounds));
        var _foreground1 = Array.isArray(foreground) ? foreground : [
            foreground
        ];
        var foregrounds = _toConsumableArray(_foreground1).concat(_toConsumableArray(orderedFallbackForegrounds));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = foregrounds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var f = _step.value;
                if (!f) continue;
                var contrast = chroma.contrast(_background, f);
                if (contrast >= compliantContrastRatio) {
                    return {
                        color: f,
                        contrastRatio: Number(contrast).toFixed(2)
                    };
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } catch (e) {
        console.error('Unable to calculate an appropriate contrast color given the provided props in useContrastText from @cvent/carina-color:', props, e);
    }
    return null;
};
export var useContrastText = function(props) {
    var ref;
    return ((ref = useContrastTextDetails(props)) === null || ref === void 0 ? void 0 : ref.color) || null;
};
export default useContrastText;
